"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var PlaceholderLine_1 = __importStar(require("./PlaceholderLine"));
var PlaceholderImage_1 = __importStar(require("./PlaceholderImage"));
var linear = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    background-position: -468px 0;\n  }\n  to {\n    background-position: 600px 0;\n  }\n"], ["\n  from {\n    background-position: -468px 0;\n  }\n  to {\n    background-position: 600px 0;\n  }\n"])));
var Placeholder = function (props) {
    var children = props.children, className = props.className, column = props.column;
    return (react_1.default.createElement(PlaceholderWrapper, { className: (0, classnames_1.default)('man-ui placeholder', className), column: column }, children));
};
exports.Placeholder = Placeholder;
var PlaceholderWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-direction: ", ";\n\n  & ", ", ", " {\n    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);\n    background-size: 1200px 100%;\n    animation: ", " 1s linear forwards infinite;\n  }\n\n  & ", " {\n    margin: 4px 0;\n\n    :first-child {\n      margin: 0 0 4px 0;\n    }\n\n    :last-child {\n      margin: 4px 0 0 0;\n    }\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  flex-direction: ", ";\n\n  & ", ", ", " {\n    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);\n    background-size: 1200px 100%;\n    animation: ", " 1s linear forwards infinite;\n  }\n\n  & ", " {\n    margin: 4px 0;\n\n    :first-child {\n      margin: 0 0 4px 0;\n    }\n\n    :last-child {\n      margin: 4px 0 0 0;\n    }\n  }\n"])), function (props) { return (props.column ? 'column' : 'row'); }, PlaceholderLine_1.Line, PlaceholderImage_1.Image, linear, PlaceholderLine_1.Line);
exports.Placeholder.Line = PlaceholderLine_1.default;
exports.Placeholder.Image = PlaceholderImage_1.default;
exports.default = exports.Placeholder;
var templateObject_1, templateObject_2;
